var map = {
	"./americanexpress.png": "9c9c",
	"./amex.png": "323b",
	"./bank.png": "e6ce",
	"./default.png": "1f6c",
	"./mastercard.png": "eee9",
	"./unionpay.png": "acad",
	"./visa.png": "8f38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d938";